// extracted by mini-css-extract-plugin
export default {"root":"ForgotPasswordForm_root__CSeT6","form":"ForgotPasswordForm_form__bviLl","button":"ForgotPasswordForm_button__EZInT"};